interface CustomIconMobileChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconMobileChannel({ width, height }: CustomIconMobileChannelProps) {
  return (
    <svg fill="none" width={width || 32} height={height || 32} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#1c1c28" strokeWidth="2">
        <path
          clipRule="evenodd"
          d="m21.948 8.40338c.9919 0 2.2824-.70313 3.2567-.45499.5688.14485 1.1562.52999 1.7621 1.15541-.932.51824-1.3979 1.3316-1.3979 2.4402s.4659 1.8991 1.3979 2.3715c-.9059 1.8105-1.6759 2.878-2.3099 3.2027-1.0364.5307-1.6494-.6888-2.7459-.2807-.8086.3008-1.1548.5197-1.8931.4938-1.5836-.0556-2.9693-2.9964-3.1979-4.1396-.6968-3.48451 1.0796-5.24331 2.7286-5.24331.8316 0 1.7155.45499 2.3994.45499zm2.4541-4.40338c0 .7688-.1974 1.37149-.5921 1.80809-.3948.43659-1.0124.79929-1.853 1.08811-.0932-.58052.0873-1.20835.5414-1.88349s1.0886-1.01271 1.9037-1.01271z"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="m5.30957 15.1904 8.69043 9.3096" />
        <path d="m13.9761 19.5237-8.97622 9.2857" />
        <path
          d="m17.0085 22.5429-11.09211 6.0742c-.41255.2259-.91639-.0726-.91639-.5429v-12.1485c0-.4704.50384-.7689.91639-.543l11.09211 6.0742c.4289.2349.4289.8511 0 1.086z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
